"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirQualityThresholds = exports.AirQualityEventType = void 0;
var AirQualityEventType;
(function (AirQualityEventType) {
    AirQualityEventType["InternalAirQuality"] = "AIR_QUALITY";
    AirQualityEventType["ExternalAirQuality"] = "OUTDOOR_AIR_QUALITY";
    AirQualityEventType["AQI"] = "aqi";
    AirQualityEventType["AirPressure"] = "air_pressure";
    AirQualityEventType["CoolantPressure"] = "coolant_pressure";
    AirQualityEventType["FilterMain"] = "FILTER_STATUS_MAIN";
    AirQualityEventType["FilterSecondary"] = "FILTER_STATUS_SECONDARY";
    AirQualityEventType["Temperature"] = "TEMPERATURE";
    AirQualityEventType["Humidity"] = "HUMIDITY";
})(AirQualityEventType = exports.AirQualityEventType || (exports.AirQualityEventType = {}));
exports.AirQualityThresholds = {
    eaq: {
        good: 350,
        moderate: 859,
        unhealthy: 860,
    },
    iaq: {
        excellent: 50,
        good: 100,
        lightlyPolluted: 150,
        moderatelyPolluted: 200,
        heavilyPolluted: 250,
        severelyPolluted: 350,
        extremelyPolluted: 500,
    },
    pm25: {
        good: 0.28,
        moderate: 0.68,
    },
    // BME688 BSEC outputs co2Equivalent and breathVoc as DERIVED values
    // (both scaled from gas resistance), not direct CO2 or atmospheric TVOC
    // measurements. Their scales run higher than real-world atmospheric ppm:
    //  - co2Equivalent: 400 to 30000+ ppm, scaled from VOC-to-CO2 assumed ratio
    //  - breathVoc: 0 to 1000 ppm, where 1000 is the saturation ceiling
    // The previous thresholds (co2 good=800/poor=5000, voc good=0.65/poor=10)
    // were calibrated for atmospheric reference scales, which made the cards
    // show "Unhealthy" on >60-97% of samples in deployed field data.
    // The values below were derived empirically from 12 days of data on two
    // deployed hubs (~6000 samples), targeting ~30% Good / ~40% Moderate /
    // ~25-30% Poor distribution for typical occupied indoor environments.
    co2: {
        good: 1500,
        moderate: 3500,
        poor: 6000,
    },
    voc: {
        good: 100,
        moderate: 600,
        poor: 999,
    },
};
